import { container, singleton } from "tsyringe";
import CommentLikeApi from "api/clapaction/projects/[id]/config/forum/posts/[postId]/comments/[commentId]/CommentLikeApi";
import toValidationError from "utils/toValidationError";

@singleton()
export default class CommentLikeService {
	private commentLikeApi: CommentLikeApi = container.resolve(CommentLikeApi);

	/**
	 * @description Count all likes on a comment
	 */
	public async count(projectId: string, postId: string, commentId: string): Promise<{ count: number }> {
		return this.commentLikeApi.count(projectId, postId, commentId).catch(toValidationError);
	}

	/**
	 * @description Check if the user liked a comment
	 */
	public async isLiked(projectId: string, postId: string, commentId: string): Promise<{ isLiked: boolean }> {
		return this.commentLikeApi.isLiked(projectId, postId, commentId).catch(toValidationError);
	}

	/**
	 * @description Like a comment
	 */
	public async like(projectId: string, postId: string, commentId: string): Promise<void> {
		return this.commentLikeApi.like(projectId, postId, commentId).catch(toValidationError);
	}

	/**
	 * @description Unlike a comment
	 */
	public async unlike(projectId: string, postId: string, commentId: string): Promise<void> {
		return this.commentLikeApi.unlike(projectId, postId, commentId).catch(toValidationError);
	}
}
